import React from 'react';
import SkeletonWrapper from '@shared/components/skeleton/SkeletonWrapper';
import TimelineChart from './TimelineChart';
import { getPluralSuffix } from '../../../../../utils/plurals';
import { TIMELINE_TYPES } from '../../../constants/timelineTypes';

/**
 * @typedef {object} TimelineSectionTimelineData
 * @property {Date} [timelineDate]
 * @property {number} [type]
 * @property {Array<*>} [orgUnits]
 */

/**
 * @typedef {object} TimelineSectionProps
 * @property {TimelineSectionTimelineData[]} [timelineData]
 * @property {boolean} [loading]
 */

/**
 * @param {TimelineSectionProps} props
 */
const TimelineSection = props => {
  const { timelineData = [], loading = false } = props;

  const totalEnrolledUnitsCount = timelineData
    .filter(item => item.type === TIMELINE_TYPES.ENROLLED)
    .flatMap(timelineEntry => timelineEntry.orgUnits)
    .flatMap(orgUnit => orgUnit.units).length;

  return (
    <section className='timeline-section'>
      <SkeletonWrapper show={loading}>
        <h4>{`Timeline of ${totalEnrolledUnitsCount} Site${getPluralSuffix(
          totalEnrolledUnitsCount
        )}`}</h4>
      </SkeletonWrapper>

      <SkeletonWrapper show={loading} inheritParentSize>
        <TimelineChart timelineItems={timelineData} />
      </SkeletonWrapper>
    </section>
  );
};

export default TimelineSection;
